/**
 * scribble-in animation: M5.T2.
 *
 * Per IMPLEMENTATION_PLAN.md §7 M5.T2:
 *   "stroke-dashoffset from 100% → 0% over 200ms, ease-out-quad. Applied
 *    to specific surfaces (lobby chips on join, REVEAL banner entrance,
 *    GAME_OVER MVP cards)."
 *
 * The actual CSS lives inline in `client/index.html` so it ships in the
 * critical-first-paint sheet (mirrors the wordmark-scribble-in pattern
 * from M2.T10d). The source-of-truth copy lives in
 * `client/src/styles/anim.css` and is asserted by `anim.test.ts`.
 *
 * Usage: add `SCRIBBLE_IN_CLASS` to any element whose descendant `<path>`,
 * `<circle>`, or `<line>` elements should "draw in." The stylesheet sets
 * `stroke-dasharray: 200` + animates `stroke-dashoffset` from 200 → 0,
 * which renders as a hand-drawn-in stroke for paths under ~200 SVG units
 * (all of `client/src/marks/v1/`).
 *
 * Reduced motion: `@media (prefers-reduced-motion: reduce)` cancels the
 * animation: strokes appear instantly. The contract is enforced by
 * `anim.test.ts`.
 */

export const SCRIBBLE_IN_CLASS = "scribble-in";

/**
 * The CSS keyframe name. Exposed so consumers can reference it (debug
 * tooling, devtools queries) without re-stringifying it.
 */
export const SCRIBBLE_IN_KEYFRAME = "scribble-in-stroke";

/**
 * Duration the animation plays for, in ms. Mirrors the keyframe.
 *
 * Useful when callers need to coordinate state changes with the visual
 * (e.g. "play the scribble-in, then enable a button", schedule a
 * `setTimeout(..., SCRIBBLE_IN_DURATION_MS)`).
 */
export const SCRIBBLE_IN_DURATION_MS = 200;
